/**
 * @generated SignedSource<<7c0a577082071eef2af6fcbef958aa69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
import { FragmentRefs } from "relay-runtime";
export type AsanaIntegrations_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly hasAccessToAsanaIntegration: boolean;
    };
  };
  readonly integrations: {
    readonly asana: {
      readonly connectedProject: {
        readonly externalId: string | null;
        readonly id: string;
        readonly name: string;
        readonly syncEnabled: boolean | null;
        readonly type: string | null;
        readonly workspaceExternalId: string | null;
      } | null;
      readonly email: string;
      readonly id: string;
      readonly includeAiGenerated: boolean;
      readonly isConnected: boolean;
      readonly lastSyncDate: string | null;
      readonly syncedActionItemCount: number | null;
      readonly unsyncedActionItemCount: number;
    } | null;
    readonly userLevelActionItemIntegration: {
      readonly id: string;
      readonly integrationProvider: IntegrationProvider;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AsanaIntegrationAddProjectContent_viewer">;
  readonly " $fragmentType": "AsanaIntegrations_viewer";
};
export type AsanaIntegrations_viewer$key = {
  readonly " $data"?: AsanaIntegrations_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AsanaIntegrations_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AsanaIntegrations_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "hasAccessToAsanaIntegration",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "asana_integration"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"asana_integration\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AsanaUserNode",
          "kind": "LinkedField",
          "name": "asana",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isConnected",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AsanaProjectNode",
              "kind": "LinkedField",
              "name": "connectedProject",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "workspaceExternalId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "syncEnabled",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "includeAiGenerated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unsyncedActionItemCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncedActionItemCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastSyncDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserActionItemIntegrationNode",
          "kind": "LinkedField",
          "name": "userLevelActionItemIntegration",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "integrationProvider",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AsanaIntegrationAddProjectContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "67c78cd867f2c30423990a3cbf9b1a01";

export default node;
